import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { QuestionBox } from './styles';
import StartAgain from './start-again';
import GPS from './gps';
import Postcode from './postcode';

const useType = {
  GPS: 'GPS',
  POSTCODE: 'POSTCODE',
  NONE: null,
};

export const Heading = styled.h4`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

/**
 * Provides the user the choice of GPS, Postcode or List selection
 * to find and choose their Local Authority.
 */
const LocationSelector = ({ lookup }) => {
  const [use, setUse] = useState(useType.NONE);

  return (
    <QuestionBox $isAnAnswer={false}>
      <Heading>What is your location?</Heading>

      {(use === useType.NONE || use === useType.POSTCODE) && (
        <Postcode
          lookup={(value) => lookup({ type: 'postcode', value })}
          cancel={() => {
            setUse(useType.NONE);
          }}
        />
      )}

      {/** GPS provides its own button, to trigger the navigator call */}
      {use === useType.NONE || use === useType.GPS ? (
        <GPS
          inUse={() => setUse(useType.GPS)}
          lookup={(pos) => {
            lookup({ type: 'gps', value: pos });
          }}
          cancel={() => {
            setUse(useType.NONE);
          }}
        />
      ) : null}

      {use !== useType.NONE ? (
        <StartAgain
          cancel={() => {
            setUse(useType.NONE);
          }}
        />
      ) : null}
    </QuestionBox>
  );
};

LocationSelector.propTypes = {
  lookup: PropTypes.func.isRequired,
};

export default LocationSelector;
